import { CONTROLLER_SCHEDULE_ROLES } from "./permissions";
import { ADMIN, DEPARTMENT_MANAGER, EMPLOYEES, INVENTORY, MANAGER, SU_ADMIN, TECHNICIAN } from "./roles";
import { PLUGIN_NAME } from "./const";
import {
    AccessibilityNewRounded,
    AnchorRounded,
    Cached,
    DescriptionOutlined,
    EqualizerRounded,
    Extension,
    ExtensionRounded,
    FmdGoodOutlined,
    HomeRepairServiceOutlined,
    Inventory2Rounded,
    NotificationsActiveOutlined,
    PeopleOutlineRounded,
    PermContactCalendarRounded,
    PermIdentityRounded,
    PlaylistAddCheckRounded,
    ReceiptLong,
    RestorePageOutlined,
    SensorWindow,
    SettingsOutlined,
    SettingsRemoteOutlined,
    SpaceDashboardRounded,
    SpeedRounded,
    StorefrontRounded,
    SupportAgentOutlined,
    WorkHistoryOutlined,
    WorkOutlineOutlined,
    Workspaces,
    WorkspacesOutlined,
    WorkspacesRounded,
} from "@mui/icons-material";

export const MENU_PAGES = [
    //#region - Pages //
    {
        title: "DASHBOARD",
        icon: <EqualizerRounded />,
        path: "/Dashboard",
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        plugins: [PLUGIN_NAME.CALENDAR],
        title: "CALENDAR",
        icon: <PermContactCalendarRounded color="primary" />,
        path: "/Calendar",
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        title: "SERVICE_CALL_ACTIVE",
        icon: <HomeRepairServiceOutlined color="primary" />,
        path: "/Service-Call/Active",
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        title: "SERVICE_CALL_APPROVAL",
        icon: <WorkOutlineOutlined color="primary" />,
        path: "/Service-Call/Approval",
        showRoles: [DEPARTMENT_MANAGER],
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        title: "SCHEDULE_SERVICES_CALL",
        icon: <WorkHistoryOutlined color="primary" />,
        path: "/Schedule-ServicesCall",
        showRoles: [DEPARTMENT_MANAGER],
    },
    {
        prods: [PLUGIN_NAME.MICRO_CONTROLLERS],
        title: "CONTROL_AND_MONITORING",
        icon: <SettingsRemoteOutlined color="primary" />,
        path: "/Control-And-Monitoring",
        showRoles: [EMPLOYEES, TECHNICIAN],
    },
    {
        prods: [PLUGIN_NAME.METER_READ],
        title: "METER_READING",
        icon: <SpeedRounded color="primary" />,
        path: "/Meter-Read",
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        title: "CHECK_LIST",
        icon: <PlaylistAddCheckRounded color="primary" />,
        path: "/Check-List",
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        plugins: [PLUGIN_NAME.SUPPLIERS],
        title: "SUPPLIER_ORDERS",
        icon: <ReceiptLong color="primary" />,
        path: "/Supplier-Orders",
        showRoles: [MANAGER],
    },
    //#endregion

    //#region - System Pages //
    {
        prods: [PLUGIN_NAME.SYSTEM],
        title: "SCAN_SITE",
        icon: <SensorWindow color="primary" />,
        path: "/Scan-Site",
        showRoles: [ADMIN],
    },
    {
        prods: [PLUGIN_NAME.SYSTEM],
        title: "MICRO_CONTROLLERS_MANAGER",
        icon: <SensorWindow color="primary" />,
        path: "/Micro-Controllers-Manager",
        showRoles: [INVENTORY, TECHNICIAN],
    },
    //#endregion

    //#region - History and reports //
    {
        icon: "Divider",
        title: "HISTORY",
        showRoles: [DEPARTMENT_MANAGER],
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        title: "SERVICE_CALL_HISTORY",
        icon: <RestorePageOutlined color="primary" />,
        path: "/Service-Call/History",
        showRoles: [DEPARTMENT_MANAGER],
    },
    {
        title: "REPORTS",
        icon: <DescriptionOutlined color="primary" />,
        path: "/Reports",
        showRoles: [DEPARTMENT_MANAGER],
    },
    //#endregion

    //#region Settings and admin //
    {
        icon: "Divider",
        title: "SETTINGS",
        showRoles: [DEPARTMENT_MANAGER],
    },
    {
        title: "BIZ_SETTINGS",
        icon: <SettingsOutlined color="primary" />,
        path: "/Biz-Settings",
        showRoles: [SU_ADMIN],
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        plugins: [PLUGIN_NAME.CLIENTS],
        title: "CLIENTS",
        icon: <AccessibilityNewRounded color="primary" />,
        path: "/Clients",
        showRoles: [MANAGER],
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        plugins: [PLUGIN_NAME.ITEMS],
        title: "ITEMS",
        icon: <Inventory2Rounded color="primary" />,
        path: "/Items",
        showRoles: [MANAGER],
    },
    {
        plugins: [PLUGIN_NAME.EMPLOYEES],
        title: "EMPLOYEES",
        icon: <PermIdentityRounded color="primary" />,
        path: "/Employees",
        showRoles: [DEPARTMENT_MANAGER],
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        plugins: [PLUGIN_NAME.SUPPLIERS],
        title: "SUPPLIERS",
        icon: <WorkspacesOutlined color="primary" />,
        path: "/Suppliers",
        showRoles: [DEPARTMENT_MANAGER],
    },
    {
        plugins: [PLUGIN_NAME.EMPLOYEES],
        title: "DEPARTMENTS",
        icon: <PeopleOutlineRounded color="primary" />,
        path: "/Departments",
        showRoles: [MANAGER],
    },
    {
        prods: [PLUGIN_NAME.MICRO_CONTROLLERS],
        title: "AREAS",
        icon: <FmdGoodOutlined color="primary" />,
        path: "/Areas",
        showRoles: [MANAGER],
    },
    {
        prods: [PLUGIN_NAME.MICRO_CONTROLLERS],
        title: "CONTROLLER_SCHEDULES",
        icon: <PermContactCalendarRounded color="primary" />,
        path: "/Controller-Schedules",
        showRoles: CONTROLLER_SCHEDULE_ROLES,
    },
    {
        prods: [PLUGIN_NAME.SERVICES_CALL],
        plugins: [PLUGIN_NAME.MINI_SITE],
        title: "MINI_SITES",
        icon: <SpaceDashboardRounded color="primary" />,
        path: "/Mini-Site",
        showRoles: [SU_ADMIN],
    },
    {
        prods: [PLUGIN_NAME.MICRO_CONTROLLERS],
        title: "MICRO_CONTROLLERS",
        icon: <SettingsRemoteOutlined color="primary" />,
        path: "/Micro-Controllers",
        showRoles: [DEPARTMENT_MANAGER, TECHNICIAN],
    },
    {
        prods: [PLUGIN_NAME.METER_READ],
        title: "METER",
        icon: <SpeedRounded color="primary" />,
        path: "/Meters",
        showRoles: DEPARTMENT_MANAGER,
    },
    //#endregion

    //#region Support //
    {
        icon: "Divider",
        title: "",
    },
    {
        title: "NOTIFICATION",
        icon: <NotificationsActiveOutlined color="primary" />,
        path: "/Notification",
        showRoles: [EMPLOYEES],
    },
    {
        title: "SUPPORT",
        icon: <SupportAgentOutlined color="primary" />,
        path: "/support",
    },
    {
        title: "INIT",
        icon: <Cached color="primary" />,
        path: "/init",
    },
    //#endregion

    //#region Admin /
    {
        icon: "Divider",
        title: "ADMIN_AREA",
        showRoles: [SU_ADMIN],
    },
    {
        title: "PLANS",
        icon: <WorkspacesRounded color="primary" />,
        path: "/Plans",
        showRoles: [SU_ADMIN],
    },
    {
        title: "PLUGINS",
        icon: <ExtensionRounded color="primary" />,
        path: "/Plugins",
        showRoles: [SU_ADMIN],
    },
    {
        title: "PLANS_MANAGEMENT",
        icon: <Workspaces color="primary" />,
        path: "/Plans-Manager",
        showRoles: [SU_ADMIN],
    },
    {
        title: "PLUGINS_MANAGER",
        icon: <Extension color="primary" />,
        path: "/Plugins-Manager",
        showRoles: [SU_ADMIN],
    },
    {
        title: "MICRO_CONTROLLERS_MANAGER",
        icon: <SensorWindow color="primary" />,
        path: "/Micro-Controllers-Manager",
        showRoles: [SU_ADMIN],
    },
    {
        title: "BUSINESS_MANAGER",
        icon: <StorefrontRounded color="primary" />,
        path: "/Select-Business",
        showRoles: [SU_ADMIN],
    },
    {
        title: "LOGS",
        icon: <AnchorRounded color="primary" />,
        path: "/Logs",
        showRoles: [SU_ADMIN],
    },
    //#endregion
];
